import { Boundaries } from "@planzone/core";
import { State } from "./types";

function handleDuplicateProject(
  state: State,
  { project, zone }: Boundaries["duplicateProject"]["success"],
): State {
  return state.map((req) => ({
    ...req,
    zones: req.zones.map((z) =>
      z.uuid === zone.uuid
        ? {
            ...z,
            projects: [...z.projects, { ...project }],
          }
        : z,
    ),
  }));
}
export { handleDuplicateProject };
